import Cookie from './cookie'

const bitrixFormCookie = () => {

    // console.log(123)
    //
    // $(document).on('keyup', '.b24-form input', function () {
    //     // let inputName = $(this).attr('name');
    //     // let inputValue = $(this).val();
    //     //
    //     // Cookie.set(inputName, inputValue, 48 * 60);
    //
    //
    //     let inputName = $(this).attr('name');
    //     let inputValue = $(this).val();
    //
    //     Cookie.set('bitrix-forms['+inputName+']', inputValue, 48 * 60);
    // });
    //
    //
    //
    // $(document).on('DOMNodeInserted', function(e) {
    //     if ( $(e.target).hasClass('b24-form') ) {
    //         // console.log($('.b24-form'))
    //
    //         setTimeout(() => {
    //             $('.b24-form input').each(function (){
    //                 let inputName = $(this).attr('name');
    //                 let inputValue = $(this).val();
    //                 let val = Cookie.get('bitrix-forms['+inputName+']')
    //
    //                 if(val && inputValue == '') {
    //                     $(this).parents('.b24-form-field').removeClass('b24-form-control-alert')
    //                     $(this).addClass('b24-form-control-not-empty').val(val).trigger('focus')
    //                 }
    //
    //                 // console.log($(this).val())
    //             });
    //
    //             $('input[name="name"]' ).val(555).change().trigger('change').trigger('keyup').trigger('keydown').focus().val(666).keyup().keypress().keydown().click()
    //
    //             const event = new KeyboardEvent('keyup', {
    //                 key: 'Enter',
    //             });
    //
    //             document.querySelector('.b24-form-control').dispatchEvent(event);
    //
    //             // setTimeout(() => {
    //             //     $('input[name="name"]' ).val(6666).change().trigger('change').focus()
    //             // },2000)
    //         }, 2000)
    //
    //
    //         //element with .MyClass was inserted.
    //     }
    // });

    // $(".b24-form2").ready(function(){
    //     console.log($('.b24-form'))
    // });





    // console.log(Cookie.get())
    // console.log(Cookie.get('bitrix-forms'))

};

export default bitrixFormCookie;
